export const PENLYPLAY_RESET = 'PENLYPLAY_RESET';
export const PENLYPLAY_STATE_UPDATED = 'PENLYPLAY_STATE_UPDATED';
